import React, { useEffect } from 'react'
import { HotelCrossSellComponent } from '@pcln/bundle-and-save-components'
import { logCrossSell } from '../../../../common/log-ga-event/logGaEvent-cross-sell'

function CrossSellGenericAd(props) {
  const { handleHotelCrossSellClick, ecommerceData, creativeSlot = 'listings_top' } = props

  useEffect(() => {
    logCrossSell({
      pageName: 'listings',
      filterType: 'listings',
      creativeName: 'updated_hotel_static_xsell_banner',
      locationId: 'hero_banner',
      creativeSlot,
      promotionId: 'hotel_static_xsell_banner',
      promotionName: 'hotel',
      bundleFlag: 'n',
      bundleType: 'n',
      ecommerce: ecommerceData,
    })
  }, [])

  return (
    <HotelCrossSellComponent
      mx={[2, 2, 2, 2, 0]}
      isLightBackground
      handleClick={handleHotelCrossSellClick}
      isNewDesign={false}
    />
  )
}

export { CrossSellGenericAd }
